import { Directive } from '@angular/core';

@Directive({ selector: 'app-page-actions' }) // tslint:disable-line
export class PageActionsDirective {}

@Directive({ selector: 'app-page-content' }) // tslint:disable-line
export class PageContentDirective {}

@Directive({ selector: 'app-page-title' }) // tslint:disable-line
export class PageTitleDirective {}

@Directive({ selector: 'app-page-subtitle' }) // tslint:disable-line
export class PageSubtitleDirective {}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/page/page.directive.ts